




























import { Component, Prop, Vue } from 'vue-property-decorator';
import Close from '@/components/icons/Close.vue';

@Component({
  components: {
    Close
  }
})
export default class HowManyCoinsShouldIgive extends Vue {
  @Prop({ default: false }) readonly showCloseButton?: boolean;
  get businessCurrencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
